import _ from 'lodash';

const toNullableString = value => (_.isNil(value) || value === '' ? null : value);

export class ContactCustomFieldDefinitionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getContactCustomFieldDefinitions(params = {}) {
    return this.#http.get('/api/contact-custom-field-definitions', { params });
  }

  async createContactCustomFieldDefinition(data) {
    return this.#http.post('/api/contact-custom-field-definitions', data);
  }

  async updateContactCustomFieldDefinition(id, data) {
    if (!id) {
      throw new Error('Missing ID for update operation');
    }

    if (!data) {
      throw new Error('Missing data for update operation');
    }

    const sanitizedData = {
      name: data.name,
      description: toNullableString(data.description),
      expressionKey: data.expressionKey,
      target: data.target,
      valueType: data.valueType,
      isEnabled: _.isBoolean(data.isEnabled) ? data.isEnabled : false,
      companyId: data.companyId,
      isGlobal: _.isBoolean(data.isGlobal) ? data.isGlobal : false,
      valueSource: {
        type: toNullableString(data.valueSource?.type),
        isRequired: !!data.valueSource?.isRequired,
        readOnly: !!data.valueSource?.readOnly,
      },
      defaultValue: _.isNil(data.defaultValue) ? null : data.defaultValue,
    };

    return this.#http.put(`/api/contact-custom-field-definitions/${id}`, sanitizedData, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async deleteContactCustomFieldDefinition(id) {
    return this.#http.delete(`/api/contact-custom-field-definitions/${id}`);
  }

  async upsertContactCustomFieldDefinitionOverride(id, data) {
    if (!id) {
      throw new Error('Missing ID for override upsert');
    }

    const body = {
      isEnabled: _.isBoolean(data?.isEnabled) ? data.isEnabled : null,
      description: _.isNil(data?.description) ? null : data.description,
      defaultValue: _.isNil(data?.defaultValue) ? null : data.defaultValue,
    };

    return this.#http.put(`/api/contact-custom-field-definitions/${id}/override`, body, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async deleteContactCustomFieldDefinitionOverride(id) {
    if (!id) {
      throw new Error('Missing ID for override delete');
    }

    return this.#http.delete(`/api/contact-custom-field-definitions/${id}/override`);
  }

  async getContactCustomFieldValues(contactId) {
    return this.#http.get(`/api/contacts/${contactId}/custom-fields`);
  }

  async saveContactCustomFieldValues(contactId, values) {
    return this.#http.put(`/api/contacts/${contactId}/custom-fields`, values, {
      headers: { 'Content-Type': 'application/json' },
    });
  }
}
